export function cleaningPickupAlreadySentDialogHtml(): string {
  return `<form method="dialog" class="bulk-confirm-card">
    <h2 id="cleaning-pickup-already-sent-title">本日は既に送信履歴があります。</h2>
    <div class="bulk-confirm-actions">
      <button class="button secondary" type="submit" value="close" autofocus>閉じる</button>
    </div>
  </form>`;
}

export function openCleaningPickupAlreadySentDialog(showModal: (dialog: HTMLDialogElement) => void): void {
  if (document.getElementById("cleaning-pickup-already-sent-dialog")) return;
  const dialog = document.createElement("dialog");
  dialog.id = "cleaning-pickup-already-sent-dialog";
  dialog.className = "bulk-confirm-dialog";
  dialog.setAttribute("aria-labelledby", "cleaning-pickup-already-sent-title");
  dialog.innerHTML = cleaningPickupAlreadySentDialogHtml();
  dialog.addEventListener("close", () => dialog.remove(), { once: true });
  // The request's finally block rerenders the app; keep the notice outside that root.
  document.body.appendChild(dialog);
  showModal(dialog);
}
